export const PHONE_DISPLAY = "484-639-8659";
export const PHONE_TEL = "tel:+14846398659";
export const SMS_NUMBER = "4846398659";
export const EMAIL = "alkennedy238@gmail.com";
export const MAILTO = `mailto:${EMAIL}`;

export const QUOTE_SMS_BODY = `Hi, I'm interested in getting a quote from Freedom Mobile Auto Detailing.

Vehicle year:
Make:
Model:
Vehicle type:
Location:
Vehicle condition:`;

export const smsLink = (body) =>
  body ? `sms:${SMS_NUMBER}?&body=${encodeURIComponent(body)}` : `sms:${SMS_NUMBER}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Pricing", id: "pricing" },
  { label: "About", id: "about" },
  { label: "Service Area", id: "service-area" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1565381169814-50def2eb0387?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwcmVzc3VyZSUyMHdhc2glMjBjYXIlMjB3aGVlbHxlbnwwfHx8fDE3ODkzMzQyNTR8MA&ixlib=rb-4.1.0&q=85",
  exterior:
    "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fGJsYWNrfDE3ODkzMzQyNTF8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fGJsYWNrfDE3ODkzMzQyNTF8MA&ixlib=rb-4.1.0&q=85",
  wheels:
    "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fGJsYWNrfDE3ODkzMzQyNTF8MA&ixlib=rb-4.1.0&q=85",
  truck:
    "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxwcmVzc3VyZSUyMHdhc2glMjBjYXIlMjB3aGVlbHxlbnwwfHx8fDE3ODkzMzQyNTR8MA&ixlib=rb-4.1.0&q=85",
  dashboard:
    "https://images.unsplash.com/photo-1710083521061-c1b1701c5d95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxjYXIlMjBpbnRlcmlvciUyMHZhY3V1bXxlbnwwfHx8fDE3ODkzMzQyNTF8MA&ixlib=rb-4.1.0&q=85",
};

export const INTERIOR_ITEMS = [
  "Thorough deep vacuum",
  "Seats vacuumed",
  "Carpet vacuumed",
  "Floor mats removed and cleaned",
  "Cloth seat extraction when needed",
  "Carpet extraction and stain cleaning when needed",
  "Interior surfaces wiped and cleaned",
  "Dashboard cleaned",
  "Center console cleaned",
  "Door panels cleaned",
  "Cupholders cleaned",
  "Interior windows cleaned",
  "General stain treatment where possible",
];

export const EXTERIOR_ITEMS = [
  "Vehicle pre-rinse",
  "Foam cannon wash",
  "Hand wash",
  "Exterior rinse",
  "Wheels cleaned",
  "Tires cleaned",
  "Exterior windows cleaned",
  "Vehicle dried",
  "Tire shine applied",
];

export const PRICING = [
  { name: "Car", price: "$120", examples: ["Sedans", "Coupes", "Small hatchbacks"] },
  { name: "SUV", price: "$140", examples: ["Small and midsize SUVs"] },
  { name: "Truck / 3-Row SUV", price: "$160", examples: ["Pickup trucks", "Larger SUVs", "3-row SUVs"] },
  { name: "Large SUV / Van", price: "$180+", examples: ["Full-size SUVs", "Vans", "Oversized vehicles"] },
];

export const VEHICLE_TYPES = ["Car", "SUV", "Truck", "3-Row SUV", "Large SUV", "Van", "Work Vehicle", "Other"];

export const CONDITIONS = ["Light Cleaning", "Average", "Dirty", "Very Dirty", "Heavy Stains / Pet Hair"];

export const GOOGLE_REVIEW_URL = "";

export const FAQS = [
  {
    q: "Do you come to my location?",
    a: "Yes. Freedom Mobile Auto Detailing is a mobile service. We come to your home, workplace, or another agreed-upon location within our service area.",
  },
  {
    q: "Do I need to provide water or electricity?",
    a: "Contact us when booking so we can confirm the setup needed for your appointment.",
  },
  {
    q: "How long does a detail take?",
    a: "Timing depends on the size and condition of the vehicle. Heavily soiled vehicles, stains, pet hair, or larger vehicles may require additional time.",
  },
  {
    q: "Can you remove every stain?",
    a: "We use extraction and stain-cleaning methods when needed, but some permanent or deeply set stains may not be completely removable.",
  },
  {
    q: "Do you clean cloth seats?",
    a: "Yes. Cloth seats can be vacuumed and extracted when necessary as part of the detailing process.",
  },
  {
    q: "Do you clean pet hair?",
    a: "Yes, but excessive pet hair may require additional time and could affect pricing.",
  },
  {
    q: "Do you detail work trucks?",
    a: "Yes. Work trucks and small commercial fleets are welcome. Contact us for custom pricing.",
  },
  {
    q: "How do I book?",
    a: "Fill out the quote form or text 484-639-8659 with your vehicle's year, make, model, location, and condition.",
  },
  {
    q: "Do prices ever change?",
    a: "The listed prices are starting prices based on typical vehicle conditions. Extremely dirty vehicles, excessive stains, pet hair, oversized vehicles, or unusually time-consuming jobs may cost more. Any pricing differences should be communicated before work begins.",
  },
];
